import { lightenColor } from "lib/tenant/colorUtils";

export function createButtonStyles(primaryColor: string) {
  const hoverColor = lightenColor(primaryColor, 0.25);

  return {
    baseStyle: {
      outline: "none",
      padding: "0 4",
      fontWeight: 500,
      _focus: { boxShadow: "none" },
      _disabled: {
        bg: "#CCCCCC",
        color: "#808080",
        border: "1px solid #CCCCCC",
        fontWeight: "400",
        opacity: 1,
        pointerEvents: "none",
      },
    },
    sizes: {},
    variants: {
      primary: () => ({
        bg: primaryColor,
        borderRadius: "8px",
        fontSize: "16px",
        border: `1px solid ${primaryColor}`,
        color: "#FFFFFF",
        fontWeight: "500",
        _hover: {
          bg: hoverColor,
          boxShadow: "md",
          color: "#fff",
          border: `1px solid ${hoverColor}`,
          _disabled: {
            backgroundColor: "#CCCCCC",
            border: "none",
            color: " #808080",
          },
        },
        _active: {
          bg: primaryColor,
        },
      }),
      secondary: () => ({
        bg: "#EEEEEE",
        borderRadius: "4px",
        fontSize: "16px",
        fontWeight: "500",
        _hover: {
          bg: "#E5EBF5",
          boxShadow: "md",
          outline: "none",
        },
      }),
      secondaryOutline: () => ({
        bg: "white",
        borderRadius: "8px",
        fontSize: "16px",
        border: `1px solid ${primaryColor}`,
        color: primaryColor,
        fontWeight: "500",
        _hover: {
          bg: hoverColor,
          boxShadow: "md",
          color: "#fff",
          border: `1px solid ${hoverColor}`,
        },
        _active: {
          bg: primaryColor,
        },
      }),
    },
    defaultProps: {
      variant: "primary",
    },
  };
}

export const ButtonStyles = createButtonStyles("#1246EA");
